import { MailQuestion } from 'lucide-react'
import { useAuth } from '@/auth/auth-provider'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { BrandMark } from '@/components/brand-mark'

/**
 * Signed in, but not on any team.
 *
 * GoTrue's magic-link endpoint is open by design — anyone who knows the URL can
 * request a link and end up with a valid session. Membership, not
 * authentication, is what grants access to a team's content, and RLS enforces
 * that server-side. This screen is the honest UI for that state: you're
 * authenticated, and there is nothing here for you yet.
 */
export function NoAccess() {
  const { profile, session, signOut } = useAuth()
  const email = profile?.email ?? session?.user?.email

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/40 px-4">
      <div className="w-full max-w-md">
        <div className="mb-7 flex justify-center">
          <BrandMark className="h-11 w-11" />
        </div>
        <Card>
          <CardHeader>
            <div className="mb-1 flex items-center gap-2">
              <MailQuestion className="h-4 w-4 text-muted-foreground" />
              <CardTitle className="text-base">You&apos;re signed in, but not on a team yet</CardTitle>
            </div>
            <CardDescription>
              This portal is organized by team, and{' '}
              <span className="font-medium text-foreground">{email}</span> hasn&apos;t been added to
              one.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-sm text-muted-foreground">
              Ask your Don&apos;t Panic Labs coach to invite this address. Invitations are matched by
              email, so once they add you, signing in again is all it takes.
            </p>
            <div className="flex gap-2">
              <Button variant="outline" className="flex-1" onClick={() => window.location.reload()}>
                Check again
              </Button>
              <Button variant="ghost" onClick={() => void signOut()}>
                Sign out
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
